import React from 'react';
import { motion } from 'framer-motion';
export function App() {
  return <div className="min-h-screen bg-background text-cream overflow-hidden relative" data-id="element-0">
      {/* Full-screen image as background/hero */}
      <div className="fixed inset-0 z-0" data-id="element-1">
        <motion.img src="https://cdn.magicpatterns.com/uploads/7Y95RdeNaXCti9zHoV1hS4/photo_2025-04-13_19.07.36.jpg" alt="Artistic dancer emerging through golden archway" className="w-full h-full object-cover object-center" initial={{
        scale: 1.1,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} data-id="element-2" />
        {/* Subtle gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-background/80 via-background/40 to-transparent" data-id="element-3" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-background/30" data-id="element-4" />
      </div>

      {/* Content overlay */}
      <main className="relative z-10 min-h-screen flex flex-col justify-between px-8 md:px-16 lg:px-24 py-12 md:py-16" data-id="element-5">
        {/* Top: Established date */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.5
      }} data-id="element-6">
          <span className="text-gold-light/80 tracking-[0.3em] uppercase text-xs md:text-sm font-light" data-id="element-7">
            Est. 2026
          </span>
        </motion.div>

        {/* Center: Company name */}
        <motion.div className="flex flex-col justify-center" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.2,
        delay: 0.8
      }} data-id="element-8">
          <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-bold leading-[0.9] tracking-tight" data-id="element-9">
            <motion.span className="block text-cream" initial={{
            opacity: 0,
            x: -40
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 1,
            delay: 1
          }} data-id="element-10">
              IMPROBABLE
            </motion.span>
            <motion.span className="block text-gold-light" initial={{
            opacity: 0,
            x: -40
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 1,
            delay: 1.3
          }} data-id="element-11">
              ARTS
            </motion.span>
          </h1>

          <motion.p className="mt-8 md:mt-12 text-cream/60 text-sm md:text-base lg:text-lg font-light tracking-wide max-w-md" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 1.8
        }} data-id="element-12">
            We produce contemporary dance performances and immersive theatrical experiences that explore the boundaries of human perception and creative expression
          </motion.p>
        </motion.div>

        {/* Bottom: Domain */}
        <motion.div className="self-start" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 2.2
      }} data-id="element-13">
          <span className="text-cream/40 tracking-[0.2em] uppercase text-xs md:text-sm font-light" data-id="element-14">
            improbablearts.com
          </span>
        </motion.div>
      </main>
    </div>;
}